<template>
  <button
    class="group w-full flex items-center pl-2"
    @click="$emit('navigate')"
  >
    <div class="flex items-center grow truncate">
      <Indicator
        v-if="variant"
        size="sm"
        :variant="variant"
        mode="solid"
        :isGroup="isGroup"
      />
      <div
        class="pr-2 ml-3 py-1.5 flex justify-between grow h-full w-full truncate"
        :class="{
          'border-b border-secondary': divider,
        }"
      >
        <div class="h-7.5 flex items-center gap-3 w-full truncate">
          <div
            v-if="label"
            class="text-base md:text-sm font-medium text-primary truncate"
          >
            {{ label }}
          </div>
          <div
            v-else-if="placeholder"
            class="text-base md:text-sm font-medium text-placeholder_subtle"
          >
            {{ placeholder }}
          </div>
          <Badge
            v-if="count"
            type="modern"
            color="gray"
            :label="count"
            :size="!maxSmall ? 'sm' : 'md'"
          />
        </div>
        <div
          class="flex items-center"
          :class="{ 'group-disabled:hidden': icon == 'edit-pen' }"
        >
          <Tooltip :title="tooltip" :disabled="!tooltip">
            <IconButton variant="tertiary" type="gray" size="xs">
              <Icon :name="icon" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup>
import { computed } from "vue";
import { Badge } from "@/SharedComponents/Badges";
import { IconButton } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { Indicator } from "@/SharedComponents/Indicator";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useI18n } from "vue-i18n";

// Breakpoints
const { maxSmall } = useBreakpoints();

// Define Emits
defineEmits(["navigate"]);

// Define Props
const props = defineProps({
  variant: { type: String, required: false },
  label: { type: String, required: false },
  placeholder: { type: String, required: false },
  count: { type: [String, Number], required: false },
  divider: { type: Boolean, default: false },
  isGroup: { type: Boolean, default: false },
});

// Computed Props
const icon = computed(() => {
  if (props.variant == "space" || props.variant == "asset_group") {
    return "edit-pen";
  }

  return "chevron-right";
});

const { t } = useI18n();

const tooltip = computed(() => {
  if (props.variant == "space" || props.variant == "asset_group") {
    return t("tooltips.buttons.edit");
  }

  return "";
});
</script>
